import BookShipmentForm from '../../components/forms/bookShipment';

const BookShipment = () => {
  return <BookShipmentForm />;
};

export default BookShipment;
